import { filter } from 'rxjs'

import { Component } from 'src/app/core/base-component'
import { ConsentDataService } from 'src/app/services/consent-data.service'
import { ComponentType } from 'src/app/core/models/component.model'
import { ConsentModalService } from 'src/app/services/consent-modal.service'
import { Modal } from '../consent-modal/consent-modal.component'
import { ConsentWrapper } from '../consent-wrapper/consent-wrapper.component'
import { ConsentTrigger } from '../consent-trigger/consent-trigger.component'
import { AppConfigService } from 'src/app/services/app-config.service'

import { type ApiCookieConsent } from 'src/app/models/consent-data.model'
import { type CookieConsent } from '../../models/consent-data.model'

export class MainComponent extends Component {
  private modalRef!: Modal
  private readonly consentDataService: ConsentDataService
  private readonly consentModalService: ConsentModalService
  private readonly appConfigService: AppConfigService

  constructor() {
    super({
      componentName: 'cookie-info-app',
      componentType: ComponentType.Static
    })

    this.consentDataService = ConsentDataService.getInstance()
    this.consentModalService = ConsentModalService.getInstance()
    this.appConfigService = AppConfigService.getInstance()
  }

  initApp(): void {
    const cookieConsentDataFromApi: ApiCookieConsent | null = this.getCookieConsentApiData()

    if (cookieConsentDataFromApi != null) {
      this.consentDataService.setInitialCookieConsentData(cookieConsentDataFromApi)
      this.init()
    }
  }

  private init(): void {
    if (this.isPermissionsNeed()) {
      this.displayConsent()
    }

    if (this.appConfigService.getDisplayStickyTriggerState()) {
      this.addTriggerWidget()
    }

    this.addSubscriptions()
  }

  private addTriggerWidget(): void {
    const consentTriggerRef: ConsentTrigger = new ConsentTrigger()
    consentTriggerRef.renderWidget()
  }

  private addSubscriptions(): void {
    this.addSubscriptionForModalStateChanges()
  }

  private addSubscriptionForModalStateChanges(): void {
    this.consentModalService.showModal$.subscribe(() => {
      if (this.modalRef === undefined) {
        this.displayConsent()
      } else {
        this.modalRef.show()
      }
    })
  }

  private isPermissionsNeed(): boolean {
    return this.consentDataService.isLocalDataOlderThanRemoteData()
  }

  private displayConsent(): void {
    const consentWrapperRef = new ConsentWrapper()

    this.modalRef = new Modal()
    this.modalRef.setContent(consentWrapperRef.hostView)
    this.appendChild(this.modalRef.hostView)

    this.modalRef.show()
  }

  private getCookieConsentApiData(): ApiCookieConsent | null {
    return this.appConfigService.getConsentData()
  }
}
